import { useFragment } from '@apollo/client';
import type { PlanInfoFragment } from '@frameio/graphql-client/generated';
import { PlanInfo } from '@frameio/graphql-client/generated';

export function usePlanFragment(planId: string) {
  const result = useFragment<PlanInfoFragment>({
    fragment: PlanInfo,
    fragmentName: 'PlanInfo',
    from: {
      __typename: 'Plan',
      id: planId,
    },
  });

  return result;
}
